// extracted by mini-css-extract-plugin
export default {"input":"Search_input__3-h7Y","search":"Search_search__R9dbS","close":"Search_close__jE8a9"};